import { defineComponent as _defineComponent } from 'vue'
import type { PropType } from 'vue';
import { SycurioConfig } from '@white-label-types/parking-checkout';
import { getEnvironment } from '@white-label-helper/shared-helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'payment-gateway-sycurio',
  props: {
  paymentsConfig: {
    type: Object as PropType<SycurioConfig>,
    required: true,
  },
  paymentsConfigReceived: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {



const environment = getEnvironment();

return { __sfc: true,environment }
}

})